import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, DestroyRef, EventEmitter, inject, Inject, Input, Output, PLATFORM_ID } from '@angular/core';
import { CompanyPlanModel, PlanChangeRequestModel } from '../../../models/company.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { LoaderService } from '../../../core/services/loader.service';
import { FlashMessageService } from '../flash-message/flash-message.service';
import { CompanyPlansService } from './company-plans.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BootstrapModalService } from '../../../core/services/bootstrap-modal.service';

@Component({
  selector: 'app-company-plans',
  imports: [CommonModule, TranslateModule],
  templateUrl: './company-plans.component.html',
  styleUrl: './company-plans.component.scss',
  providers: [CompanyPlansService, BootstrapModalService]
})
export class CompanyPlansComponent {

  private readonly destroyRef = inject(DestroyRef);

  @Input() plans!: CompanyPlanModel[];
  @Input() activePlanUid!: string;
  @Input() featureRows!: any;
  @Input() isRegister!: boolean;
  @Input() isAnalytics!: boolean;
  @Output() planSelect = new EventEmitter<CompanyPlanModel>();

  isBrowser: boolean;
  currentUser: any;
  planChangeData: PlanChangeRequestModel = new PlanChangeRequestModel();

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: any,
    private readonly router: Router,
    public readonly loaderService: LoaderService,
    private readonly flashMessage: FlashMessageService,
    public readonly translate: TranslateService,
    public readonly companyPlanService: CompanyPlansService,
    private readonly bootstrapModalService: BootstrapModalService
  ) { this.isBrowser = isPlatformBrowser(this.platformId) }


  selectPlan(plan: CompanyPlanModel) {
    if (plan.PlanUid === this.activePlanUid) return;
    if (this.isRegister || this.isAnalytics) {
      this.planSelect.emit(plan);
    } else {
      let currentPlan = this.plans.find(p => p.PlanUid === this.activePlanUid);
      this.planChangeData.CurrentPlan = currentPlan?.PlanName!;
      this.planChangeData.CurrentPlanPrice = currentPlan?.PriceLabel!;
      this.planChangeData.RequestedPlan = plan.PlanName;
      this.planChangeData.RequestedPlanPrice = plan.PriceLabel;
      this.planChangeData.SelectedLang = this.translate.getCurrentLang();

      this.loaderService.display(true);
      this.companyPlanService.changePlanRequest(this.planChangeData).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: () => {
          if (this.isBrowser) {
            this.bootstrapModalService.open('requestSentBtnModal', {
              backdrop: 'static',
              keyboard: false
            });
          }
          this.loaderService.display(false);
        },
        error: () => {
          this.loaderService.display(false);
          this.flashMessage.showErrorAlert(
            this.translate.instant('error-message')
          );
        }
      });
    }
  }

  goToHome(): void {
    this.bootstrapModalService.close('requestSentBtnModal');
    this.router.navigate(['/home']);
  }

  closePage() {
    if (this.isAnalytics) {
      this.bootstrapModalService.close('requestSentBtnModal');
      this.router.navigate(['/profile/analytics']);
    }
  }
}
